import i18n from '@i18next/i18n';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

const RELOAD_WARNING = i18n.t('确认刷新么？有离线编辑内容，将在网络恢复后自动保存到服务器，刷新网页后，内容将丢失');

/*
*   页面关闭前检查修改是否已保存
*/
export class UnsavedChangesManager {
    public constructor(private selectionService: ISelectionService) {
        // 离开页面前检查数据状态
        window.addEventListener('beforeunload', (event) => {
            if (this.hasChangesUnSaved()) {
                const e = event || window.event;
                if (e) {
                    e.returnValue = RELOAD_WARNING;
                }
                return RELOAD_WARNING;
            }
        });
    }

    /**
     * 判断是否存在未保存的改动
     */
    private hasChangesUnSaved = () => {
        const selectedElements = this.selectionService.selectedElements.selectedArray;
        return selectedElements && !this.elementChangesSaved(selectedElements);
    };

    private elementChangesSaved(selectedElements: IElementBaseModel[]) {
        let saved = true;
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < selectedElements.length; i++) {
            if (selectedElements[i].changesSaved && !(selectedElements[i].changesSaved?.())) {
                saved = false;
                break;
            }
        }
        return saved;
    }
}
